/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCardChallengeRequestCard } from './GetCardChallengeRequestCard';
import {
    GetCardChallengeRequestCardFromJSON,
    GetCardChallengeRequestCardFromJSONTyped,
    GetCardChallengeRequestCardToJSON,
    GetCardChallengeRequestCardToJSONTyped,
} from './GetCardChallengeRequestCard';
import type { GetCardChallengeRequestBrowserInfo } from './GetCardChallengeRequestBrowserInfo';
import {
    GetCardChallengeRequestBrowserInfoFromJSON,
    GetCardChallengeRequestBrowserInfoFromJSONTyped,
    GetCardChallengeRequestBrowserInfoToJSON,
    GetCardChallengeRequestBrowserInfoToJSONTyped,
} from './GetCardChallengeRequestBrowserInfo';

/**
 * 
 * @export
 * @interface GetCardChallengeRequest
 */
export interface GetCardChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequest
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequest
     */
    countryCode?: GetCardChallengeRequestCountryCodeEnum;
    /**
     * 
     * @type {GetCardChallengeRequestCard}
     * @memberof GetCardChallengeRequest
     */
    card: GetCardChallengeRequestCard;
    /**
     * 
     * @type {GetCardChallengeRequestBrowserInfo}
     * @memberof GetCardChallengeRequest
     */
    browserInfo: GetCardChallengeRequestBrowserInfo;
}


/**
 * @export
 */
export const GetCardChallengeRequestCountryCodeEnum = {
    Es: 'ES',
    Mx: 'MX',
    Ad: 'AD',
    De: 'DE',
    Pe: 'PE',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL'
} as const;
export type GetCardChallengeRequestCountryCodeEnum = typeof GetCardChallengeRequestCountryCodeEnum[keyof typeof GetCardChallengeRequestCountryCodeEnum];


/**
 * Check if a given object implements the GetCardChallengeRequest interface.
 */
export function instanceOfGetCardChallengeRequest(value: object): value is GetCardChallengeRequest {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('card' in value) || value['card'] === undefined) return false;
    if (!('browserInfo' in value) || value['browserInfo'] === undefined) return false;
    return true;
}

export function GetCardChallengeRequestFromJSON(json: any): GetCardChallengeRequest {
    return GetCardChallengeRequestFromJSONTyped(json, false);
}

export function GetCardChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'card': GetCardChallengeRequestCardFromJSON(json['card']),
        'browserInfo': GetCardChallengeRequestBrowserInfoFromJSON(json['browserInfo']),
    };
}

export function GetCardChallengeRequestToJSON(json: any): GetCardChallengeRequest {
    return GetCardChallengeRequestToJSONTyped(json, false);
}

export function GetCardChallengeRequestToJSONTyped(value?: GetCardChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalEntityId': value['legalEntityId'],
        'countryCode': value['countryCode'],
        'card': GetCardChallengeRequestCardToJSON(value['card']),
        'browserInfo': GetCardChallengeRequestBrowserInfoToJSON(value['browserInfo']),
    };
}

